
import React from 'react';

function Header() {
    return (
        <header>
            <div data-animation="default" className="navbar w-nav" data-easing2="ease" data-easing="ease" data-collapse="medium" role="banner" data-no-scroll="1" data-duration="500" data-doc-height="1">
                <div className="container nav-container">
                    <div className="nav-menu-container">
                        <a href="index.html" aria-current="page" className="brand w-nav-brand w--current"></a>
                        <nav role="navigation" className="nav-menu w-nav-menu">
                            <div className="div-logo"><img src="/assets/images/logo.png" loading="lazy" sizes="(max-width: 991px) 100vw, (max-width: 1439px) 67px, 56.234375px" srcSet="/assets/images/logo-p-500.png 500w, /assets/images/logo-p-800.png 800w, /assets/images/logo.png 917w" alt="" className="logo-img"/>
                                <div id="w-node-_6f63e9d0-44d7-69aa-8d55-af88598beb3b-245b60b9" className="gradient-text predyctx">Trenzix</div>
                            </div>
                            <div className="link-container"></div>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
